import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

interface CalendarProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  children?: ReactNode;
}

export const Calendar: FC<CalendarProps> = ({ className, children, ...props }) => {
  const mainClassName = clsx("grid grid-cols-7 gap-y-2", className);
  return (
    <div className={mainClassName} {...props}>
      {children}
    </div>
  );
};
